import {Card, CardActionArea, CardContent, Checkbox, Grid, Typography} from "@mui/material";
import {Tag} from "~/apps/core/ui/Tag";
import {formatWeight, humanizeCargoType} from "~/apps/packages/auto-visits/utils";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import React from "react";
import {SelectableCard} from "~/apps/core/ui/SelectableCard";
import {
    OrderCargoCard
} from "~/apps/packages/auto-shipment-orders/components/OrderDetail/OrderCargoCard/OrderCargoCard";


export type CargoSelectDialogItemProps = {
    cargo: any
    selected?: boolean
    onClick?: () => void
}


export const CargoSelectDialogItem = React.memo<CargoSelectDialogItemProps>(({selected, cargo, onClick}) => {
    const handleClick = () => {
        onClick && onClick();
    }
    return (
        <CardActionArea sx={{flex: 1}} onClick={handleClick}>
            <OrderCargoCard selectable cargo={cargo} selected={selected} />
        </CardActionArea>
    )
})